<li [ngClass]="{'edit-menu-item-active':isSelectedSignal}"
  class="list-group-item edit-menu-item draggable">
  <div class="row">
    <div class="col align-items-center d-flex" (click)="onSignalStartEdit()">
      <span class="fa-solid fa-grip-vertical mr-2 text-muted"></span>
      <span class="edit-menu-item-icon">
        <em class="fa-solid fa-signal"></em>
      </span>
      <span>
        <span [innerHTML]="signal.label | translate | truncate" [ngClass]="{'signal-deleted': signalHasBeenDeleted}"></span>
        <span [innerHTML]="getSignalUnit(signal)"></span>
        @if (signalHasBeenDeleted) {
          <em [ngbTooltip]="'The signal does not exist anymore on the asset.'|translate"
            class="fa-solid fa-circle-question text-muted ml-1"
          placement="top"></em>
        }
      </span>
    </div>
    <div class="col-auto">
      <div class="edit-menu-item-functions">
        <div class="d-inline-flex" ngbDropdown>
          <button class="btn btn-xs btn-outline-secondary dropdown-no-arrow" id="dropdownBasic1"
            ngbDropdownToggle>
            <span class="fa-solid fa-ellipsis-vertical"></span>
          </button>
          <div ngbDropdownMenu>
            <button (click)="onSignalStartEdit()"
              ngbDropdownItem>
              <span class="fa-solid fa-pen"></span>
              <span [innerHTML]="'Edit signal'|translate"></span>
            </button>
            <button (click)="onSignalRemove(signal.signalId)" class="text-danger" ngbDropdownItem>
              <span class="fa-solid fa-trash"></span>
              <span [innerHTML]="'Remove signal'|translate"></span>
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
  @if (isSelectedSignal) {
    <div class="edit-menu-form">
      <scitis-signal-slices-configuration
        [signal]="signal"
        [widgetType]="widgetType">
      </scitis-signal-slices-configuration>
    </div>
  }

</li>
